module.exports = __webpack_public_path__ + "fonts/montserrat-bold.80f10bd3.woff";